import { CEViewGrantBase } from './ce-view-grant-base'


export class CEViewGrant extends CEViewGrantBase {

}